import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getLivestreamType = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/schedule-ruleset/types` });

  return data?.data;
};

export default getLivestreamType;
